import './styles.css.js';
import { memo } from 'react';
import { jsx } from 'react/jsx-runtime';

function Button(props) {
  const {
    variant = "primary",
    onClick,
    children,
    title,
    className,
    style,
    size = "md",
    disabled,
    type = "button"
  } = props;
  const sizeClass = `size-${size}`;
  return /*#__PURE__*/jsx("button", {
    disabled: disabled
    // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    className: `t-btn t-btn-${variant} w3a--rounded-full ${sizeClass} ${className}`,
    onClick: onClick,
    title: title,
    style: style,
    children: children
  });
}
var Button$1 = /*#__PURE__*/memo(Button);

export { Button$1 as default };
